import * as API from 'api'
import { httpRequest } from './initialize'
import { Operation } from '.';

/** Load user information  */
export const fetchAccountSettings = (dispatch) => {
    return API.User.fetchAccountSettingsInfo(httpRequest)
        .catch((err) => Operation.onFail('Failed to retrieve user settings', dispatch, err));
}


// WEBPACK FOOTER //
// ./src/application/settings.ts